// Expense & P&L types

export const EXPENSE_CATEGORIES = [
  'Rent', 'Salaries', 'Utilities', 'Maintenance', 'Marketing',
  'Supplies', 'Licenses & Fees', 'Equipment', 'Miscellaneous',
];

export const EXPENSE_PAYMENT_MODES = ['CASH', 'UPI', 'CARD', 'BANK', 'CHEQUE'];

export interface Expense {
  id: string;
  category: string;
  description?: string;
  amount: number;
  paymentMode?: string;
  payee?: string;
  date: string;            // yyyy-MM-dd
  organizationCode: string;
  restaurantId?: string;
  createdAt?: string;
  updatedAt?: string;
}

export interface CreateExpenseRequest {
  category: string;
  description?: string;
  amount: number;
  paymentMode?: string;
  payee?: string;
  date: string;
  organizationCode: string;
  restaurantId?: string;
}

export interface ExpenseFilters {
  org: string;
  restaurantId?: string;
  category?: string;
  start?: string;
  end?: string;
}

export interface CategoryAmount {
  category: string;
  amount: number;
}

export interface PnlReport {
  start?: string;
  end?: string;
  grossSales: number;
  gstCollected: number;
  netSales: number;
  cogs: number;
  grossProfit: number;
  expenseTotal: number;
  netProfit: number;
  orderCount: number;
  expensesByCategory: CategoryAmount[];
}
